import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";
import moment from "moment";

import HelpComponent from "../HelpComponent";

const _FM_ServicepackageShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          window.App.setState({rerenderBerthList: false})
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderBerthList === true])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('servicepackage_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/service-package/')
                    setTimeout(() => {
                      navigate('/service-package/update/' + id)
                    },500)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="type">{t('type')}</label>
              <span className="p-d-block p-text-bold">
                {formData.type}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="value">{t('value')}</label>
              <span className="p-d-block p-text-bold">
                {formData.value}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="unit">{t('unit')}</label>
              <span className="p-d-block p-text-bold">
                {formData.unit}
              </span>
            </div>
          </div>
        </div>
      </Panel>

      {formData.service_package_items && formData.service_package_items[0] &&
      <Panel className={"p-mt-3"}>
        <h3 className={"p-mt-0"}>
          {t('servicepackage_items_and_prices')}
        </h3>
        <table className={"w-100 p-datatable-table table-striped"} cellPadding={0} cellSpacing={0} border={0}>
              {formData.service_package_items.map((item, index) => {
                return (
                  <tr>
                    <td>
                      {item?.service?.name}
                    </td>
                    <td className={"p-text-right"}>
                      {currencyFormatter.format(
                        item.value, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                    </td>
                    <td className={"p-text-right"}>
                      {item.unit}
                    </td>
                  </tr>
                )
              })}
        </table>
      </Panel>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ServicepackageShowComponent);
